import { Table } from '@tanstack/react-table'
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'

import { IconButton, List, ListItem, ListItemText, Menu, Stack, Switch } from '@mui/material'
import SettingsIcon from '@mui/icons-material/Settings'

type HeaderConfigurationProps<T> = {
  table: Table<T>
}

export default function HeaderConfiguration<T>(props: HeaderConfigurationProps<T>) {
  const { table } = props

  return (
    <Stack alignItems="center" justifyContent="center">
      <PopupState variant="popover" popupId="groups-table-configuration">
        {(popupState) => (
          <>
            <IconButton {...bindTrigger(popupState)}>
              <SettingsIcon />
            </IconButton>
            <Menu {...bindMenu(popupState)} anchorOrigin={{ vertical: 'top', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
              <List>
                {table
                  .getAllLeafColumns()
                  .filter((column) => column.id !== 'actions')
                  .map((column) => (
                    <ListItem key={column.id}>
                      <ListItemText id={column.id} primary={column.columnDef.header} />
                      <Switch edge="end" onChange={column.getToggleVisibilityHandler()} checked={column.getIsVisible()} />
                    </ListItem>
                  ))}
              </List>
            </Menu>
          </>
        )}
      </PopupState>
    </Stack>
  )
}
